import SectionFeatureTemplate from "../../components/main/SectionFeatureTemplate";
import SectionForm from "../../components/main/SectionForm";
import SectionProject from "../../components/main/SectionProject";
import SectionQuestion from "../../components/main/SectionQuestion";
import SectionWebsiteChoose from "../../components/main/SectionWebsiteChoose";
import SectionWebsiteCompany from "../../components/main/SectionWebsiteCompany";
import SectionWebsiteDefinition from "../../components/main/SectionWebsiteDefinition";
import SectionWebsiteHero from "../../components/main/SectionWebsiteHero";
import SectionWebsiteSeo from "../../components/main/SectionWebsiteSeo";
import SectionWebsiteSeoBenefits from "../../components/main/SectionWebsiteSeoBenefits";
import SectionWebsiteWhy from "../../components/main/SectionWebsiteWhy";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const websiteFaqs = [
  {
    key: "1",
    q: "TrioCore thiết kế website theo mẫu có sẵn hay theo nhu cầu riêng của doanh nghiệp?",
    a: "Chúng tôi có thể triển khai theo cả hai hướng. Với doanh nghiệp cần đi nhanh, TrioCore sử dụng bộ khung giao diện đã được chuẩn hóa để rút ngắn thời gian. Với doanh nghiệp cần bản sắc riêng hoặc bài toán đặc thù, chúng tôi sẽ tùy biến lại cấu trúc, giao diện và tính năng theo mục tiêu thực tế.",
  },
  {
    key: "2",
    q: "Website sau khi bàn giao có thể tự cập nhật nội dung và mở rộng thêm tính năng không?",
    a: "Có. TrioCore ưu tiên nền tảng dễ quản trị và đủ mở để doanh nghiệp có thể cập nhật nội dung, bổ sung landing page, form, tích hợp CRM hoặc nâng cấp các tính năng bán hàng trong giai đoạn sau mà không phải làm lại toàn bộ.",
  },
  {
    key: "3",
    q: "Thiết kế website tại TrioCore có hỗ trợ SEO và tracking marketing không?",
    a: "Có. Ngay từ đầu, chúng tôi đã chú trọng cấu trúc heading, metadata, tốc độ tải trang, responsive và khả năng gắn các công cụ tracking như Google Analytics 4, Facebook Pixel hoặc TikTok Pixel để website vừa dễ tìm kiếm vừa sẵn sàng phục vụ marketing.",
  },
  {
    key: "4",
    q: "Nếu doanh nghiệp chưa rõ nên làm website theo hướng nào thì TrioCore có hỗ trợ tư vấn không?",
    a: "Có. Trước khi triển khai, TrioCore sẽ cùng doanh nghiệp làm rõ mục tiêu, nhóm khách hàng, hành vi sử dụng và luồng nội dung chính. Việc này giúp website sau khi lên không chỉ đẹp mà còn phù hợp với định hướng kinh doanh và khả năng vận hành thực tế.",
  },
  {
    key: "5",
    q: "Thời gian thiết kế và hoàn thiện một website tại TrioCore thường mất bao lâu?",
    a: "Thời gian triển khai phụ thuộc vào phạm vi giao diện, số lượng tính năng và mức độ tùy biến. Với các website giới thiệu hoặc bán hàng có cấu trúc rõ ràng, thời gian có thể được rút ngắn đáng kể. TrioCore luôn khảo sát trước và đưa ra lộ trình triển khai cụ thể để doanh nghiệp dễ chủ động kế hoạch.",
  },
  {
    key: "6",
    q: "Chi phí thiết kế website tại TrioCore được tính theo cách nào?",
    a: "Chi phí được xác định dựa trên mục tiêu sử dụng, độ phức tạp của giao diện, tính năng cần triển khai và yêu cầu tích hợp mở rộng. TrioCore ưu tiên báo giá rõ ràng theo đúng nhu cầu thực tế, tránh phát sinh không cần thiết và đảm bảo doanh nghiệp biết mình đang đầu tư vào phần nào.",
  },
  {
    key: "7",
    q: "Sau khi website vận hành, TrioCore có hỗ trợ bảo trì và nâng cấp tiếp không?",
    a: "Có. Sau khi bàn giao, TrioCore vẫn có thể tiếp tục đồng hành ở các phần như bảo trì kỹ thuật, cập nhật nội dung, tối ưu hiệu năng, bổ sung landing page hoặc nâng cấp thêm tính năng khi doanh nghiệp phát sinh nhu cầu mới.",
  },
];

const WebsiteDesign: React.FC = () => {
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Trang chủ",
        "item": "https://triocoresolutions.com.vn/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Dịch vụ",
        "item": "https://triocoresolutions.com.vn/services"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Thiết kế website",
        "item": "https://triocoresolutions.com.vn/services/website-design"
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Thiết Kế Website — TrioCore Solutions"
        description="Dịch vụ thiết kế website chuyên nghiệp, chuẩn SEO, tối ưu UI/UX và bảo mật đột phá giúp nâng cao vị thế thương hiệu doanh nghiệp trực tuyến."
        path="/services/website-design"
      />
      <JsonLd data={breadcrumbData} />
      <SectionWebsiteHero />
      <SectionWebsiteDefinition />
      <SectionWebsiteWhy />
      <SectionWebsiteSeo />
      <SectionWebsiteSeoBenefits />
      <SectionWebsiteCompany />
      <SectionWebsiteChoose />
      <SectionFeatureTemplate
        title="Mẫu website triển khai nhanh cho nhiều lĩnh vực"
        description="Các bộ khung giao diện phù hợp cho doanh nghiệp, cửa hàng, thương hiệu dịch vụ và mô hình bán hàng cần lên website nhanh nhưng vẫn đảm bảo chất lượng hiển thị và khả năng mở rộng."
      />
      <SectionProject />
      <SectionForm />
      <SectionQuestion title="Câu hỏi thường gặp về dịch vụ thiết kế website" faqs={websiteFaqs} />
    </>
  );
};

export default WebsiteDesign;
